/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import EntityOrUrlField from '../EntityOrUrlField';
import EventField from '../EventField';

const EventOrUrlField = React.forwardRef(({ entityName = 'event', ...props }, ref) => {
  return (
    <EntityOrUrlField {...props} ref={ref} entityName={entityName}>
      {({ innerRef, ...entityFieldProps }) => (
        <EventField ref={innerRef} {...entityFieldProps} extra={null} wrapperCol={{ span: 24 }} />
      )}
    </EntityOrUrlField>
  );
});

export default EventOrUrlField;
